import { IReturn, IPost, IPut, IDelete } from './dtos';

export class DataProject implements IReturn<DataProjectResponse>, IPost, IPut {
    public rowId: number;
    public firstName: string;
    public lastName: string;
    public title: string;
    public dataProjectId: string;
    public hasORCID: boolean;
    public rsnNoORCID: string;
    public orcid: string;
    public institution: string;
    public email: string;
    public phone: string;
    public addressline1: string;
    public addressline2: string;
    public city: string;
    public state: string;
    public country: string;
    public stateOther: string;
    public province: string;
    public zip: string;
    public projectTitle: string;
    public projectSummary: string;
    public fundingAvailable: boolean;
    public supportType: string;
    public supportTypeOther: string;
    public grantNumber: string;
    public projectEndMonth: string;
    public projectEndYear: string;
    public cellStimulus: boolean;
    public cellDeath: boolean;
    public type1Diabetes: boolean;
    public tissueEngineering: boolean;
    public alphaCells: boolean;
    public geneticsGenomics: boolean;
    public otherArea: boolean;
    public otherAreaText: string;
    public phoneExt: string;
    public personId: number;
    public submit: string;
    public submitted1: boolean;
    public finalSubmissionDate: string;
    public part1complete: boolean;
    public part2complete: boolean;
    public constructor(init?: Partial<DataProject>) {
        (Object as any).assign(this, init);
    }

    public createResponse() {
        return new DataProjectResponse();
    }

    public getTypeName() {
        return 'CreateDataProject';
    }
}

export class DataProjectResponse {
    public result: DataProjectBase;

    public constructor(init?: Partial<DataProjectResponse>) {
        (Object as any).assign(this, init);
    }
}

export class DataProjectBase {
    rowId: 0;
    firstName: '';
    lastName: '';
    title: '';
    hasORCID: false;
    rsnNoORCID: '';
    orcid: '';
    institution: '';
    email: '';
    phone: '';
    addressline1: '';
    addressline2: '';
    city: '';
    state: '';
    country: '';
    stateOther: '';
    province: '';
    zip: '';
    projectTitle: '';
    projectSummary: '';
    fundingAvailable: false;
    supportType: '';
    supportTypeOther: '';
    grantNumber: '';
    projectEndMonth: '';
    projectEndYear: '';
    cellStimulus: false;
    cellDeath: false;
    type1Diabetes: false;
    tissueEngineering: false;
    alphaCells: false;
    geneticsGenomics: false;
    otherArea: false;
    otherAreaText: '';
    phoneExt: '';
    personId: '';
    submitted1: false;
    finalSubmissionDate: '';
    submit: false;
    part1complete: false;
    part2complete: false;
}

export class DataProjectMiscDoc
    implements IReturn<DataProjectMiscDocResponse>, IPost {
    public dataProjectRowId: string;
    public files: any;
    public constructor(init?: Partial<DataProjectMiscDoc>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new DataProjectMiscDocResponse();
    }
    public getTypeName() {
        return 'CreateDataFile';
    }
}

export class DeleteDataProjectMiscDoc
    implements IReturn<DeleteDataProjectMiscDocResponse>, IDelete {
    public docId: string;
    public dataProjectRowId: string;
    public constructor(init?: Partial<DeleteDataProjectMiscDoc>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new DeleteDataProjectMiscDocResponse();
    }
    public getTypeName() {
        return 'DeleteDataFile';
    }
}

export class DeleteDataProjectMiscDocResponse {
    public docs: any;
    public constructor(init?: Partial<DeleteDataProjectMiscDocResponse>) {
        (Object as any).assign(this, init);
    }
}
export class DataProjectMiscDocResponse {
    public result: DataProjectMiscDocBase[];

    public constructor(init?: Partial<DataProjectMiscDocResponse>) {
        (Object as any).assign(this, init);
    }
}

export class DataProjectMiscDocBase {
    docId: 0;
    dataProjectRowId: '';
    docType: '';
    docName: '';
    docUniqueName: '';
}
export class DataProjectDegreeSelection implements IReturn<DataProjectDegreeSelectionResponse>, IPost {
    public dataProjectRowId: 0;
    public degreeList: [];
    public degreeOther: '';

    public constructor(init?: Partial<DataProjectDegreeSelection>) {
        (Object as any).assign(this, init);
    }

    public createResponse() {
        return new DataProjectDegreeSelectionResponse();
    }

    public getTypeName() {
        return 'AddDataProjectDegreeList';
    }

}

export class DataProjectDegreeSelectionResponse {
    public result: '';
    public constructor(init?: Partial<DataProjectDegreeSelectionResponse>) {
        (Object as any).assign(this, init);
    }
}
export class DataProjectPIDegreeBase {
    rowId: 0;
    dataProjectRowId: 0;
    code: 0;
    other: '';
}
